import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import ProfessionalProvider from "models/resource-management/professional-provider";
import {
  AllergyResults,
  PatientAllergy,
  PatientAllergyDelete,
  PatientAllergyEdit,
} from "pages/patient-chart/allergies/patient-allergies";
import { ConfigurationService } from "providers/configuration/configuration.service";
import { Observable } from "rxjs";
import { finalize, shareReplay } from "rxjs/operators";
import { getAllergies } from "./patient-allergies-service-mock";

export interface AllergyTypes {
  food: Record<string, number>;
  drug: Record<string, number>;
  other: Record<string, number>;
}

@Injectable()
export class PatientAllergiesService {
  private apiUrl: string;
  private mock: boolean = false;
  allergyTypes: AllergyTypes;
  private allergiesCache = new Map<number, Observable<AllergyResults>>();
  showAllergyHeaderFlag = true;
  constructor(private http: HttpClient, private config: ConfigurationService) {
    this.apiUrl = config.getConfig().apiUrl;

    if (
      this.config.getConfig().isLocal &&
      this.config.getConfig().localEndpoints.patientAllergies
    ) {
      this.apiUrl = this.config.getConfig().localEndpoints.patientAllergies;
    } else {
      this.apiUrl = this.config.getConfig().apiUrl + "/allergies";
    }
  }

  /**
   * Returns a Patient Allergy by ID
   * @param patientChartId  the chart
   * @param tenantId the tenant id
   * @returns an interface matching the Patient Allergy
   */
  /* public getMedication(patientChartId: number, tenantId: number): Observable<PatientAllergy> {
        return this.http.get<PatientAllergy>(`${this.apiUrl}/tenant/${tenantId}/patient/${patientChartId}`);
    } */

  public createAllergies(
    patientChartId: number,
    allergy: PatientAllergy
  ): Observable<PatientAllergy> {
    allergy.patientChartId = patientChartId.valueOf();
    return this.http.post<PatientAllergy>(
      `${this.apiUrl}/patient/${patientChartId}`,
      allergy
    );
  }
  public updateAllergies(
    patientChartId: number,
    allergy: PatientAllergyEdit
  ): Observable<PatientAllergy> {
    return this.http.put<PatientAllergy>(
      `${this.apiUrl}/patient/${patientChartId}/allergy/${allergy.allergyId}`,
      allergy
    );
  }

  public deleteAllergies(
    patientChartId: number,
    allergy: PatientAllergyDelete
  ): Observable<PatientAllergy> {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      body: allergy,
    };
    return this.http.delete<PatientAllergy>(
      `${this.apiUrl}/patient/${patientChartId}/allergy/${allergy.allergyId}`,
      options
    );
  }

  /**
   * Gets patient allergies by filter
   * @param patientChartId the patient to get the data for
   * @param tenantId the tenant id
   */
  public getAllergies(patientChartId: number): Observable<AllergyResults> {
    if (this.mock) {
      return getAllergies(patientChartId);
    }
    if (this.allergiesCache.has(patientChartId)) {
      return this.allergiesCache.get(patientChartId);
    }
    const shared$ = this.http
      .get<AllergyResults>(`${this.apiUrl}/patient/${patientChartId}`)
      .map((x: any) => {
        return {
          patientAllergy: x,
          professionalProviders: new Map<number, ProfessionalProvider>(),
        };
      })
      .pipe(
        finalize(() => this.allergiesCache.delete(patientChartId)),
        shareReplay(1)
      );
    this.allergiesCache.set(patientChartId, shared$);
    return shared$;
  }

  setAllergyTypeList(typeList) {
    this.allergyTypes = typeList;
  }

  getAllergyTypeList(): AllergyTypes {
    return this.allergyTypes;
  }

  getAllergiesAndDependentList(allergy) {
    let url = `${this.apiUrl}/types`;
    return this.http.get(url);
  }
}



// WEBPACK FOOTER //
// ./src/providers/patient-charts/patient-allergies-service.ts